<div class="row">
  <div class="col-md-12 col-lg-9">
    <h3 class="eb-delivery-mode__headline">
      {{ 'checkoutProgress.deliveryMode' | cxTranslate }}
    </h3>
    <ng-container
      *ngIf="fetchedDeliveryModes$ | async; else showSpinner"
    >
      <h5 class="eb-delivery-mode__select-mode-label">
        {{ 'deliveryMode.selectMethod.title' | cxTranslate }}
      </h5>
      <div class="form-check" *ngFor="let deliveryMode of supportedDeliveryModes">
        <input
          [(ngModel)]="activeDeliveryMode"
          name="deliveryMode"
          class="form-check-input"
          type="radio"
          id="deliveryMode-{{ deliveryMode.code }}"
          [value]="deliveryMode.code"
          (change)="changeMode(deliveryMode.code)"
        />
        <label
          class="eb-delivery-mode__select-method-label"
          for="deliveryMode-{{ deliveryMode.code }}"
        >
          {{ deliveryMode.name }}
        </label>
      </div>
    </ng-container>
    <div class="eb-delivery-mode__select-details">
      <h5 class="eb-delivery-mode__select-mode-label">
        {{ 'deliveryMode.selectDetails' | cxTranslate }}
      </h5>
      <div class="eb-delivery-mode__type" data-cy="complete-delivery">
        <input
          [(ngModel)]="activeShippingMethod"
          class="form-check-input"
          type="radio"
          name="shippingMethod"
          id="deliveryMode-shipping-method"
          value="complete"
          [attr.data-cy]="deliveryStartDate | cxDate: 'mediumDate' : 'UTC'"
          (change)="handleShippingMethodChange('complete')"
        />
        <label class="eb-delivery-mode__select-method-label" for="deliveryMode-shipping-method">
          {{ 'deliveryMode.selectMethod.complete' | cxTranslate }}
        </label>
        <p
          *ngIf="activeShippingMethod === 'complete' && cartContainsUnknownATP"
          class="eb-delivery-mode__requested-shipping-date"
        >
          {{ 'deliveryMode.selectMethod.cartContainsUnknownATP' | cxTranslate }}
        </p>
      </div>
      <div class="eb-delivery-mode__type">
        <input
          [(ngModel)]="activeShippingMethod"
          class="form-check-input"
          type="radio"
          name="shippingMethod"
          id="deliveryMode-complete"
          value="shipping-date"
          (change)="handleShippingMethodChange('shipping-date')"
        />
        <label class="eb-delivery-mode__select-method-label" for="deliveryMode-complete">
          {{ 'deliveryMode.selectMethod.requestShippingDate' | cxTranslate }}
        </label>

        <div
          *ngIf="activeShippingMethod === 'shipping-date'"
          class="eb-delivery-mode__requested-shipping-date"
        >
          <p *ngIf="cartContainsUnknownATP">
            {{ 'deliveryMode.selectMethod.cartContainsUnknownATP' | cxTranslate }}
          </p>
          <ng-container *ngIf="!(initialLoadOfShippingDate$ | async); else showSpinner">
            <eb-date-picker
              [minDate]="deliveryMinDate"
              (dateChange)="dateChange($event)"
              [startDate]="deliveryStartDate"
              [disableDays]="disableWeekendDays"
              [isLoading]="isFetchingNewStartDate$ | async"
            ></eb-date-picker>
          </ng-container>
        </div>
      </div>
      <div class="eb-delivery-mode__type" *ngIf="(activeCart$ | async).partialDeliveryAllowed">
        <input
          [(ngModel)]="activeShippingMethod"
          class="form-check-input"
          type="radio"
          name="shippingMethod"
          id="deliveryMode-partial"
          value="partial"
          (change)="handleShippingMethodChange('partial')"
        />
        <label class="eb-delivery-mode__select-method-label" for="deliveryMode-partial">
          {{ 'deliveryMode.selectMethod.Partial' | cxTranslate }}
        </label>
        <p>{{ 'deliveryMode.selectMethod.PartialHint' | cxTranslate }}</p>
      </div>
    </div>

    <ng-template #showSpinner>
      <eb-spinner class="eb-delivery-mode__date-spinner"></eb-spinner>
    </ng-template>
  </div>
</div>

<eb-checkout-step-buttons
  [disabled]="
    !(activeCart$ | async)?.deliveryMode?.code ||
    ((activeCart$ | async)?.completeDelivery && !deliveryMinDate) ||
    (isFetchingNewStartDate$ | async) ||
    (initialLoadOfShippingDate$ | async) ||
    !(isRequestedShippingDaySet$ | async)
  "
  (back)="back()"
  (next)="next()"
>
</eb-checkout-step-buttons>

<ng-template #showSpinner>
  <eb-spinner class="eb-delivery-mode__spinner"></eb-spinner>
</ng-template>
